import ChevronButton from "@/components/buttons/chevron-button"
import { useMemo } from "react"
import { useRef } from "react"
import { useState } from "react"
import { formatMessage } from "@/utils/format-message"
import { langStore } from "@/stores/lang-store"
import HeatmapChart from "./heatmap-chart"
import { statsBundle } from "../../stats-const"
import { clamp } from "../../stats-util"

const HeatmapMobile = ({ heatmaps, label, visualMax }) => {
  const { lang } = langStore()

  const [idx, setIdx] = useState(0)

  const tabsWrapRef = useRef(null)
  const tabRefs = useRef([]) // 버튼 refs
  const tabs = useMemo(() => heatmaps.map(([dong]) => dong), [heatmaps])

  const total = heatmaps.length
  const maxIdx = Math.max(0, total - 1)

  const dongClick = (idx) => {
    setIdx(idx)
    const el = tabRefs.current[idx]
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    })
  }

  const dongMove = (direction = "prev") => {
    const moveIdx = direction === "prev" ? clamp(idx - 1, 0, maxIdx) : clamp(idx + 1, 0, maxIdx)

    setIdx(moveIdx)
    const el = tabRefs.current[moveIdx]
    el.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    })
  }
  return (
    <>
      <div className="flex items-center gap-2 px-2 pb-1">
        <ChevronButton
          className="border border-gray-200"
          onClick={() => dongMove("prev")}
          disabled={idx === 0}
        />

        <div ref={tabsWrapRef} className="flex-1 overflow-x-auto scroll-hidden">
          <div className="flex gap-2 min-w-max">
            {tabs.map((dong, i) => (
              <button
                key={dong}
                ref={(el) => (tabRefs.current[i] = el)}
                onClick={() => dongClick(i)}
                className={`h-8 px-2.5 rounded-lg border text-sm whitespace-nowrap
                      ${i === idx ? "border-gray-900 bg-gray-900 text-white" : "border-gray-200 bg-white text-gray-700"}
                    `}
              >
                {formatMessage(statsBundle.dong[lang], { dong })}
              </button>
            ))}
          </div>
        </div>

        <ChevronButton
          className="border border-gray-200"
          onClick={() => dongMove("next")}
          disabled={idx === maxIdx}
          direction="right"
        />
      </div>

      <div className="px-2 pb-2 text-xs text-gray-500 text-center">
        {idx + 1} / {total}
      </div>

      {(() => {
        const [dong, heatmap] = heatmaps[idx]
        const { xLabels, yLabels, data } = heatmap

        return (
          <HeatmapChart
            key={dong}
            dong={dong}
            title={formatMessage(statsBundle.byDongHousehold.mobile[lang], {
              dong,
              resource: label[lang]
            })}
            xLabels={xLabels}
            yLabels={yLabels}
            data={data}
            visualMax={visualMax}
          />
        )
      })()}
    </>
  )
}

export default HeatmapMobile
